var _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCamera = function SvgCamera(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2 13C19.2 14.6569 17.8569 16 16.2 16H3C1.34315 16 0 14.6569 0 13V5.15898C0 3.50212 1.34315 2.15898 3 2.15898H4.3402C4.83341 2.15898 5.30922 1.97674 5.67623 1.64727L6.94122 0.511705C7.30823 0.182238 7.78404 0 8.27725 0H11.6126C12.0744 0 12.522 0.159812 12.8793 0.452308L14.4119 1.70667C14.7693 1.99916 15.2168 2.15898 15.6787 2.15898H16.2C17.8569 2.15898 19.2 3.50212 19.2 5.15897V13ZM18.3616 12.818C18.6324 14.2101 17.4279 15.4434 16.0298 15.2056L15.983 15.1976H3.21382C1.9511 15.3564 0.83521 14.372 0.83521 13.0993V12.8488V5.35521L0.832169 5.31977C0.716302 3.96916 1.86716 2.8513 3.21382 3.0064H4.93797C5.42977 3.0064 5.90433 2.8252 6.27097 2.49742L7.25938 1.61376C7.62602 1.28598 8.10057 1.10477 8.59237 1.10477H11.3757C11.8362 1.10477 12.2825 1.26363 12.6394 1.55454L13.8688 2.55664C14.2256 2.84754 14.672 3.0064 15.1324 3.0064H16.3911L16.623 2.97889C17.7334 2.84721 18.6322 3.86735 18.3616 4.95225V12.818Z",
    fill: "#2A3C44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5996 8.80005C13.5996 11.0092 11.8087 12.8 9.59961 12.8C7.39047 12.8 5.59961 11.0092 5.59961 8.80005C5.59961 6.59091 7.39047 4.80005 9.59961 4.80005C11.8087 4.80005 13.5996 6.59091 13.5996 8.80005ZM12.7196 8.80003C12.7196 10.5232 11.3227 11.92 9.59961 11.92C7.87649 11.92 6.47961 10.5232 6.47961 8.80003C6.47961 7.0769 7.87649 5.68003 9.59961 5.68003C11.3227 5.68003 12.7196 7.0769 12.7196 8.80003Z",
    fill: "#2A3C44"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCamera, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/camera.a968d067.svg";
export { ForwardRef as ReactComponent };